import { apiSlice } from "features/api/apiSlice";

export const customerApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    newCustomer: builder.mutation({
      query: (data) => ({
        url: "/customers",
        method: "POST",
        body: JSON.stringify({ ...data }),
      }),
      invalidatesTags: [{ type: "Customer", id: "PARTIAL-LIST" }],
    }),
  }),
})

export const { useNewCustomerMutation } = customerApiSlice;